import React from 'react'
import './DottedLoader.css'

const DottedLoader = () => {
    return (
        <div className="dotted_loader"></div>
    )
}

export default DottedLoader